module.exports = __webpack_public_path__ + "static/img/concrete-wall.f7ac32b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/concrete-wall.png
// module id = /P6+
// module chunks = 0